import { createContext, useContext, useState, useEffect } from "react";

const ProCertThemeContext = createContext();

const STORAGE_KEY = "procert_theme_mode";

const getSystemDark = () =>
  window.matchMedia("(prefers-color-scheme: dark)").matches;

export const ProCertThemeProvider = ({ children }) => {
  // 'light' | 'dark' | 'system'
  const [mode, setMode] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || "light";
  });

  const isDark = mode === "dark" || (mode === "system" && getSystemDark());

  useEffect(() => {
    const root = document.documentElement;
    const themeMeta = document.querySelector('meta[name="theme-color"]');
    if (isDark) {
      root.classList.add("dark");
      root.style.colorScheme = "dark";
      themeMeta?.setAttribute("content", "#071016");
    } else {
      root.classList.remove("dark");
      root.style.colorScheme = "light";
      themeMeta?.setAttribute("content", "#f7fbfc");
    }
    localStorage.setItem(STORAGE_KEY, mode);
  }, [mode, isDark]);

  // Listen for OS theme changes when in system mode
  const [, forceUpdate] = useState(0);
  useEffect(() => {
    if (mode !== "system") return;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = () => forceUpdate((n) => n + 1);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [mode]);

  return (
    <ProCertThemeContext.Provider value={{ isDark, mode, setMode }}>
      {children}
    </ProCertThemeContext.Provider>
  );
};

export const useProCertTheme = () => {
  const ctx = useContext(ProCertThemeContext);
  if (!ctx)
    throw new Error("useProCertTheme must be used within ProCertThemeProvider");
  return ctx;
};
